import { RESIDENTIAL_FILTER } from '@homeSearch/modules/filter/config'
import useFetch from '@hooks/useFetch'
import useProgressRouter from '@hooks/useProgressRouter'
import { mergeFilter, slugToFilter } from '@plugin/searchRoute/modules/house'
import { global } from '@store/index'
import { convertToRanges, slugToName } from '@utils'
import { assign, find, first, isEqual, size } from 'lodash-es'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useList } from 'react-use'
import { useRecoilValue } from 'recoil'
import { getSlugData, slugToQuery } from '../../../utils'
import useHouseSearchContext from '../../context'
import { getFilterRouter, getFilterTotals } from '../base'
import useParamsToFilter from '../useParams2filter'

export default function useItem({
  slugKey,
  houseRouteKey,
  alias,
  text,
  textSuffix = 's',
  isSlug = false
}) {

  const { isMobile } = useRecoilValue(global)
  const [mobile, setMobile] = useState(false)
  useEffect(() => setMobile(isMobile), [setMobile, isMobile])

  const { state, filterMeta } = useHouseSearchContext()
  // 路由上的数据
  const routeData = useMemo(() => {
    const { slug } = state
    const data = getSlugData(slug)[slugKey]
    if (!size(data)) return
    return data
  }, [state, slugKey])
  // 当前显示的data
  const [viewData, setViewData] = useState()
  // 当前的price数据，默认是路由上的price数据，用户可以操作此数据
  const [value, { set: setValue, reset: resetValue }] = useList(routeData)
  // 根据当前选择数据生成的参数，每次操作生成不同的参数
  const [, query, baseData] = useParamsToFilter({ filterMeta, state })
  const params = useMemo(() => {
    if (!query) return
    let res
    slugToQuery(state)(houseRoute => {
      houseRoute[houseRouteKey] = value
      const [filter, query] = slugToFilter(houseRoute.toSlug(), baseData, state.type)
      const combine = mergeFilter(filter, state.searchParams.filter)
      res = assign({}, query, combine ? { filter: combine } : undefined)
    })
    return res
  }, [value, query, baseData, houseRouteKey, state])
  // 根据动态参数，获取对应数据
  const { data, isLoading } = useFetch(params ? { url: RESIDENTIAL_FILTER.url, params } : null)

  // 根据用户选择，设置显示的数据
  useEffect(() => {
    if (!size(data)) return
    const d = find(data, item => alias.includes(item.alias))
    if (d) d.totals = getFilterTotals(data, !Boolean(size(value)))
    setViewData(d)
  }, [data, value, setViewData, alias])

  // 选项发生改变，更新当前数据
  const changeHandle = useCallback(value => {
    setValue(value)
  }, [setValue])

  // 确定显示操作
  const { replaceRouter } = useProgressRouter()
  const confirmHandle = useCallback((val) => {
    const { slug } = state
    const [url, newSlug] = getFilterRouter(state)(houseRoute => {
      houseRoute[houseRouteKey] = val || value
    })
    if (!isEqual(slug, newSlug)) {
      replaceRouter(url)
    }
  }, [value, replaceRouter, state, houseRouteKey])
  // 清除选择操作
  const clearHandle = useCallback(() => {
    setValue([])
    confirmHandle([])
  }, [setValue, confirmHandle])

  // 显示的文本
  const textLabel = useMemo(() => {
    let res = `${text}${textSuffix}`
    const count = size(routeData)
    if (count) {
      if (isSlug) {
        res = `${slugToName(first(routeData))}${count > 1 ? ` +${count - 1}` : ''}`
      } else {
        if (mobile && size(routeData) > 1) {
          res = `${first(routeData)}+ ${text}${textSuffix}`
        } else {
          res = `${convertToRanges(routeData)} ${text}${count === 1 && first(routeData) === 1 ? '' : textSuffix}`
        }
      }
    }
    return res
  }, [text, textSuffix, routeData, isSlug, mobile])

  return {
    routeData,
    viewData,
    isLoading,
    value,
    state,
    textLabel,
    resetValue,
    changeHandle,
    clearHandle,
    confirmHandle
  }
}
